/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Criticsrecommend2Inputs */

const id_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritikus Merekomendasikan`)
};

const ms_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengkritik Mengesyorkan`)
};

const da_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritikere Anbefaler`)
};

const de_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritiker empfehlen`)
};

const en_us2_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critics Recommend`)
};

const es_es2_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Críticos recomiendan`)
};

const es_mx2_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Críticos recomiendan`)
};

const fil_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inirerekomenda ng mga Kritiko`)
};

const fr_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommandé par les critiques`)
};

const it_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I critici raccomandano`)
};

const hu_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritikusok ajánlják`)
};

const nl_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critici bevelen aan`)
};

const no_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritikere anbefaler`)
};

const pl_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krytycy polecają`)
};

const pt_br2_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os críticos recomendam`)
};

const pt_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Críticos recomendam`)
};

const ro_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criticii recomandă`)
};

const fi_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kriitikot suosittelevat`)
};

const sv_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritiker rekommenderar`)
};

const vi_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà phê bình đề xuất`)
};

const tr_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleştirmenler Öneriyor`)
};

const cs_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritici doporučují`)
};

const bg_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Критиците препоръчват`)
};

const ru_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Критики рекомендуют`)
};

const uk_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Критики рекомендують`)
};

const ar_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يوصي به النقاد`)
};

const hi_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आलोचक अनुशंसा करते हैं`)
};

const th_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นักวิจารณ์แนะนำ`)
};

const ja_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批評家のおすすめ`)
};

const zh_cn2_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体推荐度`)
};

const zh_hant1_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒體推薦度`)
};

const ko_offerdetail_reviews_criticsrecommend2 = /** @type {(inputs: Offerdetail_Reviews_Criticsrecommend2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비평가 추천`)
};

/**
* | output |
* | --- |
* | "Critics Recommend" |
*
* @param {Offerdetail_Reviews_Criticsrecommend2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_criticsrecommend2 = /** @type {((inputs?: Offerdetail_Reviews_Criticsrecommend2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Criticsrecommend2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "da") return da_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "de") return de_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "it") return it_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "no") return no_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "th") return th_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_criticsrecommend2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_criticsrecommend2(inputs)
	return ko_offerdetail_reviews_criticsrecommend2(inputs)
});
export { offerdetail_reviews_criticsrecommend2 as "offerDetail.reviews.criticsRecommend" }